const profile = {
  getters: {
    isAdmin: (state, getters, rootState) => rootState.profile?.roles?.includes('Administrator'),
    isPulinetUser: (state, getters, rootState) => rootState.profile?.roles?.includes('Pulinet'),
    isCustomerUser: (state, getters, rootState) => rootState.profile?.roles?.includes('Customer'),
    checkUserRoles: (state, getters, rootState) => (roles) => {
      if (!roles) return true;
      if (!rootState.profile) return false;
      return roles.some((role) => {
        return rootState.profile?.roles?.includes(role);
      });
    },
    checkBackOfficeSubRoles: (state, getters, rootState) => (roles) => {
      if (!roles) return false;
      if (!rootState.profile) return false;
      return roles.some((role) => {
        return rootState.profile?.backOfficeSubRoles?.includes(role);
      });
    },
  },
};
export default profile;
